import { css } from '@/styled-system/css';

export const panelHeaderContainer = css({
  position: 'sticky',

  top: 0,
  zIndex: 'zIndexParent',
  display: 'flex',
  alignItems: 'center',
  gap: 'tighter',
  paddingInline: 'default',
  paddingBlock: 'tighter',
  background: 'bg.neutral',
  borderBottomWidth: 'default',
  borderBottomStyle: 'solid',
  borderColor: 'border.neutral',
});

export const panelBackButton = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  // eslint-disable-next-line hotpads/no-magic-numbers -- design-specific dimension; follow-up tokenization
  width: '36px',
  // eslint-disable-next-line hotpads/no-magic-numbers -- design-specific dimension; follow-up tokenization
  height: '36px',
  borderRadius: '50%',
  border: 'none',
  background: 'none',
  cursor: 'pointer',
  color: 'text.neutral',

  flexShrink: 0,
  _hover: {
    background: 'bg.softest',
  },
  _focusVisible: {
    outlineWidth: 'thick',
    outlineStyle: 'solid',
    outlineColor: 'brand.primary',
    outlineOffset: '50',
  },
});

export const panelTitle = css({
  fontSize: 'heading-xs',
  fontWeight: 'bold',
  color: 'text.neutral',
});

export const panelBody = css({
  paddingInline: 'default',
  paddingBlock: 'loose',
  display: 'flex',
  flexDirection: 'column',
  gap: '600',

  flex: 1,
});
